module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 volume = volume*1000 ;
__p += '\n';
 solidVolume = solidVolume * 1000 ;
__p += '\n';
 temperature = temperature - 273.15 ;
__p += '\n';
 if (!pour){ ;
__p += '\n';
 topCy= 114.56- (.08*volume) ;
__p += '\n';
 rectHeight= .08*volume ;
__p += '\n';
 rectY= 114.56-.08*volume ;
__p += '\n<svg xmlns="http://www.w3.org/2000/svg" height="127.36" width="92.16" version="1.2"\n        viewBox="0 0 92.16 127.36">\n    <defs>\n        <clipPath id="a">\n            <path d="M5.12 34.56H83.2v80H5.12z"/>\n            <ellipse ry="11.52" rx="39.04" cy="114.56" cx="44.46"/>\n        </clipPath>\n    </defs>\n    <g fill="none" stroke="#1e1e1e" stroke-width=".5" stroke-linecap="round" stroke-linejoin="round">\n        <path d="M9.993 116.78c0-2.691 5.808-5.065 14.647-6.469M34.511 109.247a138.06 138.06 0 018.798-.276c18.4 0 33.315 3.496 33.315 7.809M29.832 102.913c4.198-.453 8.737-.702 13.477-.702 15.828 0 29.441 2.759 35.482 6.715M7.826 108.926c2.082-1.364 5.065-2.585 8.727-3.6" stroke-width=".56301"/>\n    </g>\n    ';
 if (volume > solidVolume) { ;
__p += '\n    <g opacity=".4">\n        <ellipse ry="11.52" rx="39.04" cy="' +
((__t = ( topCy )) == null ? '' : __t) +
'" cx="44.16" fill="' +
((__t = (color)) == null ? '' : __t) +
'"/>\n        <g opacity=".6" fill="' +
((__t = (color)) == null ? '' : __t) +
'">\n            <rect width="78.08" height="' +
((__t = (rectHeight)) == null ? '' : __t) +
'" x="5.12" y="' +
((__t = (rectY)) == null ? '' : __t) +
'"/>\n            <ellipse ry="11.52" rx="39.04" cy="114.56" cx="44.46"/>\n        </g>\n    </g>\n    ';
 } ;
__p += '\n    ';
 if (solidVolume > 0) { ;
__p += '\n    <circle clip-path="url(#a)" r="';
print(Math.pow(solidVolume,1/3)*6);
__p += '" cy="125.08" cx="44.46" fill="' +
((__t = (solidColor)) == null ? '' : __t) +
'"/>\n    ';
 } ;
__p += '\n    <g fill="none" stroke-linecap="round" stroke-linejoin="round">\n        <path d="M85.725 19.519c-5.399-.583-6.876.06-11.537 1.242-.304.077-.622.158-.956.24M19.345 4.792C12.944 5.94 7.112 7.875 4.786 9.392 3.718 10.09 3.1 10.895 3.1 11.842M87.111 16.876c-1.21-.899-2.26-2.966-2.409-3.315-1.196-2.792-2.582-5.138-9.356-7.075C67.483 4.24 56.18 2.83 43.62 2.83c-6.225 0-12.14.346-17.482.969" stroke="#1e1e1e" stroke-width=".3378"/>\n        <path d="M73.99 120.104c5.273-2.546 6.48-5.772 6.48-8.495M6.19 111.609c0 5.446 4.796 12.905 37.096 12.905 11.121 0 18.982-.885 24.508-2.266" stroke="#1e1e1e" stroke-width=".56301"/>\n        <path d="M88.794 19.138c-.522-.365-1.71-.74-2.267-.855-4.497-.929-7.604-.742-12.977.592-7.74 1.92-18.431 3.108-30.241 3.108-17.322 0-31.152-2.704-37.907-6.249-1.631-.855-2.522-2.021-2.696-2.865" stroke="#323232" stroke-width=".90081"/>\n        <path d="M4.394 17.325c7.18 4.415 22.457 6.797 38.915 6.797 8.557 0 16.537-.646 23.264-1.762" stroke="#1e1e1e" stroke-width=".3378"/>\n        <path d="M4.494 22.135v90.231c0 5.32 5.017 14.239 38.815 14.239 33.796 0 38.814-8.919 38.814-14.239V30.221s-.464-7.543 6.284-8.586c.371-.057 1.36.27 1.776.254 1.903-.072 2.176-2.694-.79-5.481-4.043-3.8-2.145-7.972-10.181-10.808C71.516 2.884 58.356.755 43.309.755 19.689.755.54 5.585.54 11.37c0 4.191 3.953 4.618 3.953 10.766z" stroke="#323232" stroke-width=".90081"/>\n        <path d="M25.515 56.68a91.522 91.522 0 01-7.85-1.333M25.515 68.809a91.518 91.518 0 01-7.85-1.332M25.515 80.94a91.522 91.522 0 01-7.85-1.333M25.515 93.07a91.522 91.522 0 01-7.85-1.333" stroke="#161413" stroke-width=".81186042"/>\n        <path d="M17.666 103.867c2.376.52 5.01.968 7.849 1.332v-60.65a91.522 91.522 0 01-7.85-1.332" stroke="#000" stroke-width=".56301"/>\n    </g>\n</svg>\n';
 } ;
__p += '\n';
 if (pour){ ;
__p += '\n';
 topCx = 40.96 + .02496 * volume ;
__p += '\n';
 topCy = 102.4 - .06272 * volume ;
__p += '\n';
 polyAx = topCx - 40.32 ;
__p += '\n';
 polyAy = topCy ;
__p += '\n';
 polyBx = topCx + 40.32 ;
__p += '\n';
 polyBy = topCy ;
__p += '\n<svg xmlns="http://www.w3.org/2000/svg" height="133.76" width="115.2" version="1.2">\n    <defs>\n        <clipPath id="a">\n            <path fill="';
color;
__p += '" opacity=".6" d="M25.6 39.68L.64 102.4 73.6 128l32.64-88.32z"/>\n            <ellipse ry="11.52" rx="38.4" cy="115.2" cx="37.12" transform="rotate(20 29.12 119.36)" fill="';
color;
__p += '"/>\n        </clipPath>\n    </defs>\n    <g fill="none" stroke="#1e1e1e" stroke-width=".5" stroke-linecap="round" stroke-linejoin="round">\n        <path d="M4.736 106.034c.92-2.53 7.19-2.773 15.976-1.07M30.352 107.34c2.695.79 5.5 1.709 8.362 2.75 17.29 6.294 30.11 14.68 28.635 18.733M28.121 99.788c4.1 1.01 8.45 2.329 12.904 3.95 14.874 5.414 26.723 12.662 31.046 18.446M5.386 97.912c2.423-.569 5.644-.696 9.432-.398" stroke-width=".56301"/>\n    </g>\n    ';
 if (volume > solidVolume) { ;
__p += '\n    <g opacity=".4">\n        <ellipse ry="11.52" rx="40.32" cy="' +
((__t = (topCy)) == null ? '' : __t) +
'" cx="';
topCx;
__p += '" fill="';
color;
__p += '"/>\n        <g opacity=".6" fill="';
color;
__p += '">\n            <polygon points="' +
((__t = (polyAx)) == null ? '' : __t) +
' ' +
((__t = (polyAy)) == null ? '' : __t) +
' .64 102.4 73.6 128 ' +
((__t = (polyBx)) == null ? '' : __t) +
' ' +
((__t = (polyBy)) == null ? '' : __t) +
'"/>\n            <ellipse ry="11.52" rx="38.4" cy="115.2" cx="37.12" transform="rotate(20 29.12 119.36)"/>\n        </g>\n    </g>\n    ';
 } ;
__p += '\n    ';
 if(solidVolume > 0) { ;
__p += '\n    <circle clip-path="url(#a)" r="';
print(Math.pow(solidVolume,1/3)*6);
__p += '" cy="114.2" cx="37.12" fill="';
solidColor;
__p += '"/>\n    ';
 } ;
__p += '\n    <g stroke-linejoin="round" stroke-linecap="round" fill="none">\n        <g stroke="#1e1e1e">\n            <g stroke-width=".3">\n                <path d="M85.724 19.523c-5.399-.583-6.877.06-11.537 1.242-.304.078-.622.158-.956.24M19.345 4.797C12.944 5.945 7.113 7.88 4.786 9.397 3.718 10.095 3.1 10.9 3.1 11.846M87.11 16.88c-1.21-.898-2.26-2.965-2.409-3.314-1.196-2.792-2.582-5.138-9.356-7.075-7.863-2.248-19.166-3.657-31.726-3.657-6.224 0-12.14.346-17.481.969" stroke-width=".33783"/>\n            </g>\n            <path stroke-width=".563" d="M73.989 120.107c5.273-2.545 6.48-5.771 6.48-8.494M6.19 111.612c0 5.446 4.796 12.904 37.096 12.904 11.12 0 18.98-.885 24.507-2.266"/>\n        </g>\n        <path stroke-width=".9008" stroke="#323232" d="M88.793 19.142c-.522-.365-1.71-.74-2.267-.854-4.497-.93-7.604-.743-12.977.59-7.74 1.922-18.43 3.11-30.241 3.11-17.321 0-31.15-2.705-37.906-6.25-1.63-.855-2.522-2.021-2.695-2.865"/>\n        <path stroke-width=".33783" stroke="#1e1e1e" d="M4.394 17.33c7.18 4.415 22.457 6.797 38.915 6.797 8.557 0 16.536-.647 23.264-1.763"/>\n        <path stroke-width=".9008" stroke="#323232" d="M4.494 22.14v90.23c0 5.32 5.018 14.238 38.814 14.238 33.797 0 38.813-8.918 38.813-14.239V30.225s-.464-7.542 6.284-8.585c.371-.057 1.36.27 1.776.254 1.903-.072 2.176-2.694-.79-5.481-4.043-3.8-2.145-7.972-10.181-10.808C71.514 2.89 58.354.761 43.307.761 19.687.76.541 5.59.541 11.374c0 4.191 3.953 4.618 3.953 10.766z"/>\n        <g stroke-width=".721" stroke="#161413">\n            <path d="M25.514 56.683a91.5 91.5 0 01-7.848-1.332M25.514 68.812a91.537 91.537 0 01-7.848-1.332M25.514 80.943a91.541 91.541 0 01-7.848-1.332M25.514 93.073a91.5 91.5 0 01-7.848-1.332" stroke-width=".8118459999999998"/>\n        </g>\n        <path stroke-width=".563" stroke="#000" d="M17.666 103.87c2.376.52 5.01.968 7.849 1.333V44.554a91.5 91.5 0 01-7.85-1.332"/>\n    </g>\n</svg>\n';
 };
__p += '\n<div class= "vesselInfo"\n    ';
 if (pour){ ;
__p += '\n     style="text-align:left;"\n    ';
} ;
__p += '\n    >\n    <div class = "vesselName">\n        ' +
((__t = (name)) == null ? '' : __t) +
' <br>\n    </div>\n    ';
 if (showVesselStats) { ;
__p += '\n    <div class = "vesselStats" >\n        ' +
((__t = ( volumeString )) == null ? '' : __t) +
' @</small> ' +
((__t = (temperature.toLocaleString(language, {maximumSignificantDigits: 3, minimumSignificantDigits: 3}))) == null ? '' : __t) +
'&deg;C</sub>\n    </div>\n    ';
 } ;
__p += '\n</div>';

}
return __p
}